import { ReactElement, ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';

const __lsKey = 'video-app';

export const videoAppCtx = createContext({
  active: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setActive: (active: boolean) => undefined,
});

interface Props {
  children: ReactNode;
}

export function VideoAppContext({ children }: Props): ReactElement {
  const [active, setActive] = useState<boolean>(localStorage.getItem(__lsKey) === '1');

  const value = useMemo(() => {
    return { active, setActive };
  }, [active]);

  useEffect(() => {
    localStorage.setItem(__lsKey, active ? '1' : '0');
  }, [active]);

  return <videoAppCtx.Provider value={value}>{children}</videoAppCtx.Provider>;
}

export function useVideoAppContext() {
  const ctx = useContext(videoAppCtx);

  return ctx;
}
